import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TableDrilldownIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.71 9.07667C3.31788 9.07667 3 9.39455 3 9.78667C3 10.1788 3.31788 10.4967 3.71 10.4967H9.94863L7.96021 12.3431C7.67287 12.6099 7.65623 13.0591 7.92305 13.3465C8.18987 13.6338 8.63911 13.6504 8.92645 13.3836L12.2381 10.3085C12.2436 10.3034 12.2491 10.2982 12.2544 10.293C12.2602 10.2872 12.266 10.2814 12.2716 10.2755C12.3925 10.1482 12.4667 9.9761 12.4667 9.78667C12.4667 9.59724 12.3925 9.42514 12.2716 9.29783C12.266 9.29191 12.2602 9.2861 12.2544 9.28038C12.2491 9.2751 12.2436 9.2699 12.2381 9.26479L8.92645 6.18972C8.63911 5.9229 8.18987 5.93954 7.92305 6.22688C7.65623 6.51423 7.67287 6.96347 7.96021 7.23029L9.94863 9.07667H3.71Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.75 9.68001C20.75 10.0721 20.4321 10.39 20.04 10.39L15.3067 10.39C14.9145 10.39 14.5967 10.0721 14.5967 9.68001C14.5967 9.28788 14.9145 8.97001 15.3067 8.97001L20.04 8.97001C20.4321 8.97001 20.75 9.28788 20.75 9.68001Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4133 12.81L20.04 12.81C20.4321 12.81 20.75 13.1279 20.75 13.52C20.75 13.9121 20.4321 14.23 20.04 14.23L13.4133 14.23C13.0212 14.23 12.7033 13.9121 12.7033 13.52C12.7033 13.1279 13.0212 12.81 13.4133 12.81Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.52 16.65L20.04 16.65C20.4321 16.65 20.75 16.9679 20.75 17.36C20.75 17.7521 20.4321 18.07 20.04 18.07L11.52 18.07C11.1279 18.07 10.81 17.7521 10.81 17.36C10.81 16.9679 11.1279 16.65 11.52 16.65Z"
        fill="currentColor"
      />
    </svg>
  );
};
